/**
 * Utility functions for handling CSP nonces in client-side scripts
 */

/**
 * Gets the CSP nonce from the meta tag
 * @returns string | null - The nonce value or null if not found
 */
export function getNonceFromMeta(): string | null {
  if (typeof document === 'undefined') return null

  const metaTag = document.querySelector('meta[name="csp-nonce"]')
  // eslint-disable-next-line i18next/no-literal-string
  return metaTag ? metaTag.getAttribute('content') : null
}

/**
 * Gets the CSP nonce from the window object
 * @returns string | null - The nonce value or null if not found
 */
export function getNonceFromWindow(): string | null {
  if (typeof window === 'undefined') return null

  return (window as Window & { __CSP_NONCE__?: string }).__CSP_NONCE__ || null
}

/**
 * Gets the CSP nonce from available sources (meta tag or window)
 * @returns string | null - The nonce value or null if not found
 */
export function getNonce(): string | undefined {
  return getNonceFromWindow() ?? getNonceFromMeta() ?? undefined
}

export const HEADER_NONCE = 'x-nonce'
